import { sanitizeDataField } from './dataFieldUtils'

export default {
  props: {
    instance: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    dataFieldFor(index) {
      return sanitizeDataField(`${this.instance}-${index}`)
    }
  }
}
